import type React from 'react';
import { useEffect, useRef, useState } from 'react';

export interface SidebarGroupProps {
  children: React.ReactNode;
}

export const SidebarGroup: React.FC<SidebarGroupProps> = ({ children }) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if all children elements have been rendered
    if (parentRef.current && !parentRef.current.children.length) {
      setIsVisible(false);
    }
  }, [parentRef]);

  if (!isVisible) return null;
  return (
    <div ref={parentRef} className={`relative before:mx-5 before:my-2.5 before:block before:h-0.5 before:bg-white/20 before:content-[''] last:mb-2 [&>a]:no-underline `}>
      {children}
    </div>
  );
};
